<template>
	<div class="modal-container">
		<div class="modal-wrapper">
			<div class="warning-container invited-member-modal">
				<div class="modal-close text-primary" @click="onClose">
					&times;
				</div>
				<div class="warning-modal-title">
					{{ $tc('modals.wizardInvitedMembers.title') }}
				</div>
				<div class="warning-modal-body" v-html="$t('modals.wizardInvitedMembers.mainText')" />
				<div class="buttons-container mt-25">
					<tooltip class="invited-member-tooltip" :text="$tc('modals.wizardInvitedMembers.shopButtonTooltip')">
						<a class="button-light-blue opacity-hover" href="/my/plans/?isInvitedMember=true">
							{{ $tc('modals.wizardInvitedMembers.shopButtonText') }}
						</a>
					</tooltip>
					<tooltip class="invited-member-tooltip" :text="$tc('modals.wizardInvitedMembers.teamGamesButtonTooltip')">
						<a class="button-light-blue opacity-hover" href="/my/auth/login/">
							{{ $tc('modals.wizardInvitedMembers.teamGamesButtonText') }}
						</a>
					</tooltip>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { ModalMixin } from '~/assets/vue/mixins'
import { Tooltip } from '~/components/interface'

export default {
	name: 'ModalWizardInvitedMembers',
	components: {
		Tooltip
	},
	mixins: [ModalMixin]
}
</script>

<style lang="scss">
.modal-container {
	position: absolute;
	display: flex;
	height: 100%;
	width: 100%;

	.modal-mask {
		position: absolute;
		z-index: 100;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.3);
		/*display: table;*/
		transition: opacity 0.3s ease;
	}
}

.modal-wrapper {
	display: flex;
	width: 100%;
	align-items: center;
	justify-content: center;
	z-index: 101;
}

.warning-container.invited-member-modal {
	width: 371px;
	height: 225px;
	margin: 0px auto;
	background-color: #fff;
	border-radius: 2px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
	transition: all 0.3s ease;
	border: #EEEEEE solid 6px;
	display: flex;
	flex-direction: column;
	align-items: center;
	position: relative;

	.modal-close {
		position: absolute;
		right: 10px;
		font-size: 24px;
		cursor: pointer;
		color: #000000;
	}

	@include respond-below(phone) {
		width: calc(100% - 32px);
	}

	.warning-modal-title {
		font-family: 'Rubik';
		font-weight: bold;
		margin-top: 30px;
		margin-bottom: 28px;
		font-size: 24px;
		line-height: 14px;
		color: #000000;
		text-align: center;
		width: 240px;
	}

	.warning-modal-body {
		font-family: 'Rubik';
		font-weight: normal;
		font-size: 14px;
		line-height: 18px;
		color: #000000;
		text-align: center;
		margin-bottom: 10px;
		width: 292px;
	}

	.buttons-container {
		display: flex;
		justify-content: space-around;
		width: 90%;

		.button-light-blue {
			font-family: 'Rubik';
			font-size: 14px;
			padding: 10px 5px;
			flex: 1 0 50%;
			font-weight: 300;
			margin-right: 10px;
			max-width: 160px;
		}

		.invited-member-tooltip {
			display: flex;
			width: 100%;
		}
	}
}
</style>
